import {LOCALE_ID, NgModule, Provider, isDevMode} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoginPage} from "./pages/login/login-page.component";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {Interceptor} from "./services/interceptor";
import {AuthGuard} from "./services/auth.guard";
import {FormCompleteComponent} from "./components/auth/form-complete/form-complete.component";
import {FormLoginComponent} from "./components/auth/form-login/form-login.component";
import {FormRegistrationComponent} from "./components/auth/form-registration/form-registration.component";
import { ShowHidePasswordComponent } from './components/show-hide-password/show-hide-password.component';
import {SharedModule} from "./shared/shared.module";
import localeRu from '@angular/common/locales/ru';
import {registerLocaleData} from "@angular/common";
import { ServiceWorkerModule } from '@angular/service-worker'

registerLocaleData(localeRu, 'ru');

const INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  multi: true,
  useClass: Interceptor
};

@NgModule({
  declarations: [
    AppComponent,
    LoginPage,
    FormLoginComponent,
    FormRegistrationComponent,
    FormCompleteComponent,
    ShowHidePasswordComponent
  ],
  imports: [
  BrowserModule,
    SharedModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode()
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
    })
  ],
  providers: [
    AuthGuard,
    INTERCEPTOR_PROVIDER,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: 'ru' }
  ],
  bootstrap: [
    AppComponent
  ]
})

export class AppModule {}
